import {
  modifyEmbeddedFlowConfig,
  receiveEmbeddedFlowConfig,
  setEmbeddedFlowConfigIsBusy,
  closeEmbeddedFlowConfig,
  setEmbeddedFlowConfigHasValidationError
} from './embedded-flow-config.actions';
import itemReducer from '../../../items/item.reducers';

const embeddedFlowConfigReducer = itemReducer(
  receiveEmbeddedFlowConfig,
  setEmbeddedFlowConfigIsBusy,
  modifyEmbeddedFlowConfig,
  closeEmbeddedFlowConfig,
  undefined,
  setEmbeddedFlowConfigHasValidationError
);

export default embeddedFlowConfigReducer;
